import React, { Component } from "react";
import { Form, Col, Row, Button } from "react-bootstrap";
import ToggleButton from 'react-toggle-button';
import imgCamelLogo from '../../assets/images/main-logo-white.png';
import "./PublishMicrositeForm.scss";

class PublishMicrositeForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: '',
      sitePath: '/',
      description: '',
      selectedCta: '', // the id of the current CTA
      enablePersonalization: true // avatar and contact info
    }
  }

  componentDidMount() {
  }

  onChangeValue = (type, value) => {
    if (type === 'title') {
      const pathString = ('/' + value.split(' ').join('-')).toLowerCase();
      this.setState({ title: value, sitePath: pathString });
    }

    this.setState({ [type]: value });
  }

  onSubmit = (e) => {
    e.preventDefault();

    const sitePath = this.state.sitePath.substr(1, this.state.sitePath.length - 1);
    
    this.props.createSite({
      title: this.state.title,
      description: this.state.description,
      path: sitePath,
      collectionId: this.props.collection.id,
      enablePersonalization: this.state.enablePersonalization,
      ctaId: this.state.selectedCta || null
    });

    this.props.onConfirm();
  }

  render() {
    const {
      title,
      sitePath,
      description
    } = this.state;

    return (
      <Form className="publish-microsite-form" onSubmit={this.onSubmit}>
        <div className="form-header">
          <img src={imgCamelLogo} alt="logo" />
        </div>
        <div className="p-4">
          <h3>Publish a New Site</h3>
          <Form.Group as={Row} controlId="micrositeTitle">
            <Col sm="6">
              <Form.Control
                type="text"
                className="mr-4"
                placeholder="Site Title"
                value={title}
                onChange={(e) => this.onChangeValue("title", e.target.value)}
                required
              />
            </Col>
            <Col sm="6">
              <Form.Control
                type="text"
                placeholder="/path"
                value={sitePath}
                onChange={(e) => this.onChangeValue("sitePath", e.target.value)}
                required
                disabled={true}
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} controlId="micrositeDescription">
            <Col sm="12">
              <Form.Control
                as="textarea"
                rows="4"
                placeholder="Description for site visitors..."
                value={description}
                onChange={(e) => this.onChangeValue("description", e.target.value)}
              />
            </Col>
          </Form.Group>

          {/* CTA */}
          { this.props.ctas && this.props.ctas.length > 0 &&
          <Form.Group as={Row} controlId="ctaSelection">
            <Col sm="12">
              {/* <Form.Label>Select CTA</Form.Label> */}
              <Form.Control
                as="select"
                value={this.state.selectedCta || ""}
                onChange={(e) => {
                  const selected = e.target.value;
                  // If a CTA is selected, disable personalization.
                  this.setState({ 
                    selectedCta: selected, 
                  });
                }}
              >
                <option value="">
                  -- Select a CTA --
                </option>
                {this.props.ctas &&
                  this.props.ctas.map((cta) => (
                    <option key={cta.id} value={cta.id}>
                      {cta.name}
                    </option>
                  ))}
              </Form.Control>
            </Col>
          </Form.Group>
          }

          {/* Personalization */}
          <Form.Group as={Row} controlId="enablePersonalization">
            <Col className="d-flex align-items-center mt-2 ml-2">
              <ToggleButton
                value={this.state.enablePersonalization}
                thumbStyle={{ borderRadius: 2 }}
                trackStyle={{ borderRadius: 2 }}
                colors={{
                  active: {
                    base: "rgb(76,210,126)",
                  },
                }}
                onToggle={(value) => {
                  this.setState({
                    enablePersonalization: !value,
                  });
                }}
              />
              <p className="ml-2 mb-0">
                {this.state.enablePersonalization
                  ? "Profile picture and personal contact info will be included"
                  : "Profile picture and personal contact info will be removed."}
              </p>
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="actionsContainer">
            <Col className="d-flex justify-content-end actions-container">
              <Button variant="outline-danger" className="mr-2" size="sm" onClick={this.props.onClose}>
                CANCEL
              </Button>
              <Button type="submit" variant="outline-danger" size="sm">
                PUBLISH
              </Button>
            </Col>
          </Form.Group>
        </div>
      </Form>
    );
  }
}

export default PublishMicrositeForm;
